import React from "react";
export function AppsListIcon(props) {
  return props.type === "home" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M15 21L24 14L33 21V32C33 32.5304 32.7893 33.0391 32.4142 33.4142C32.0391 33.7893 31.5304 34 31 34H17C16.4696 34 15.9609 33.7893 15.5858 33.4142C15.2107 33.0391 15 32.5304 15 32V21Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 34V24H27V34"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : props.type === "events" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <g clipPath="url(#clip0_346_70945)">
        <path
          d="M32 15H16C14.8954 15 14 15.8954 14 17V27C14 28.1046 14.8954 29 16 29H32C33.1046 29 34 28.1046 34 27V17C34 15.8954 33.1046 15 32 15Z"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 33H28"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 29V33"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_346_70945">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "ai" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <g clipPath="url(#clip0_346_70954)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5971 14.6398C20.5971 14.938 20.5203 15.2183 20.3854 15.4619L22.0251 17.4067H25.7678L27.4073 15.4621C27.2723 15.2185 27.1954 14.9382 27.1954 14.6399C27.1954 13.7014 27.9561 12.9407 28.8945 12.9407C29.8329 12.9407 30.5937 13.7014 30.5937 14.6399C30.5937 15.5783 29.8329 16.3391 28.8945 16.3391L28.8904 16.3391L27.9903 17.4067H29.8072C31.7623 17.4067 33.3471 18.9915 33.3471 20.9466V30.8587C33.3471 32.8138 31.7623 34.3986 29.8072 34.3986H18.1967C16.2416 34.3986 14.6568 32.8138 14.6568 30.8587V20.9466C14.6568 18.9915 16.2416 17.4067 18.1967 17.4067H19.8026L18.9024 16.339L18.898 16.339C17.9596 16.339 17.1988 15.5783 17.1988 14.6398C17.1988 13.7014 17.9596 12.9406 18.898 12.9406C19.8364 12.9406 20.5971 13.7014 20.5971 14.6398ZM29.8072 19.1058H18.1967C17.1801 19.1058 16.3559 19.93 16.3559 20.9466V30.8587C16.3559 31.8753 17.1801 32.6995 18.1967 32.6995H29.8072C30.8238 32.6995 31.648 31.8753 31.648 30.8587V20.9466C31.648 19.93 30.8238 19.1058 29.8072 19.1058ZM20.6001 24.9441C21.5385 24.9441 22.2992 24.1834 22.2992 23.2449C22.2992 22.3065 21.5385 21.5457 20.6001 21.5457C19.6617 21.5457 18.901 22.3065 18.901 23.2449C18.901 24.1834 19.6617 24.9441 20.6001 24.9441ZM29.0955 23.2449C29.0955 24.1834 28.3348 24.9441 27.3964 24.9441C26.458 24.9441 25.6973 24.1834 25.6973 23.2449C25.6973 22.3065 26.458 21.5457 27.3964 21.5457C28.3348 21.5457 29.0955 22.3065 29.0955 23.2449ZM19.7506 28.0226C19.2814 28.0226 18.901 28.403 18.901 28.8722C18.901 29.3414 19.2814 29.7218 19.7506 29.7218H28.2461C28.7154 29.7218 29.0957 29.3414 29.0957 28.8722C29.0957 28.403 28.7154 28.0226 28.2461 28.0226H19.7506ZM12.9558 21.3321C13.4836 21.3321 13.9116 21.7601 13.9116 22.2879V26.5359C13.9116 27.0638 13.4836 27.4917 12.9558 27.4917C12.4279 27.4917 12 27.0638 12 26.5359V22.2879C12 21.7601 12.4279 21.3321 12.9558 21.3321ZM36.0002 22.2879C36.0002 21.7601 35.5723 21.3321 35.0444 21.3321C34.5166 21.3321 34.0887 21.7601 34.0887 22.2879V26.5359C34.0887 27.0638 34.5166 27.4917 35.0444 27.4917C35.5723 27.4917 36.0002 27.0638 36.0002 26.5359V22.2879Z"
          fill="#E9E9E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_346_70954">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "leads" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M14.4001 22.7952C14.4001 21.6792 14.839 20.6089 15.6203 19.8198C16.4016 19.0307 17.4612 18.5873 18.5661 18.5873H22.1888C22.2341 18.5873 26.9707 18.5416 31.5171 14.6997C31.7018 14.5431 31.9269 14.4429 32.166 14.411C32.4051 14.3791 32.6483 14.4167 32.867 14.5195C33.0857 14.6222 33.2708 14.7859 33.4006 14.9911C33.5305 15.1964 33.5997 15.4349 33.6001 15.6785V29.9119C33.6013 30.1563 33.5327 30.3958 33.4026 30.6018C33.2725 30.8078 33.0864 30.9716 32.8665 31.0736C32.6994 31.1529 32.5168 31.1935 32.3322 31.1925C32.0336 31.1927 31.7447 31.0857 31.5171 30.8907C27.8854 27.8171 24.1088 27.1768 22.7322 27.0396V30.4516C22.7333 30.6629 22.6826 30.8713 22.5846 31.058C22.4866 31.2447 22.3444 31.4041 22.1707 31.5218L21.1744 32.1896C20.963 32.325 20.7183 32.3979 20.468 32.4C20.3134 32.4001 20.1601 32.3722 20.0152 32.3177C19.8233 32.2455 19.652 32.1269 19.5162 31.9721C19.3804 31.8174 19.2843 31.6314 19.2363 31.4304L18.1405 26.9847C17.1148 26.8762 16.1652 26.3882 15.4746 25.6147C14.7839 24.8411 14.4012 23.8368 14.4001 22.7952ZM32.2144 30.0582C32.2422 30.0807 32.2759 30.0944 32.3113 30.0977C32.3468 30.101 32.3823 30.0936 32.4137 30.0765C32.4445 30.0621 32.4705 30.0388 32.4882 30.0095C32.5059 29.9802 32.5147 29.9462 32.5133 29.9119V15.6785C32.5147 15.6441 32.5059 15.6102 32.4882 15.5809C32.4705 15.5516 32.4445 15.5282 32.4137 15.5138L32.3322 15.4955C32.3105 15.4949 32.2889 15.4986 32.2687 15.5064C32.2485 15.5143 32.2301 15.5261 32.2144 15.5412C28.2386 18.9075 24.1722 19.5387 22.7322 19.6576V25.9327C24.1722 26.0517 28.2386 26.6828 32.2144 30.0582ZM20.2959 31.1651C20.303 31.193 20.3165 31.2188 20.3353 31.2405C20.3541 31.2621 20.3777 31.279 20.4042 31.2897C20.4307 31.3004 20.4593 31.3046 20.4877 31.302C20.5161 31.2995 20.5435 31.2902 20.5676 31.2749L21.5639 30.6071C21.5893 30.5902 21.6101 30.5671 21.6243 30.5399C21.6386 30.5127 21.6458 30.4823 21.6454 30.4516V27.003H19.2635L20.2959 31.1651ZM18.5661 25.9053H21.6454V19.685H18.5661C17.7495 19.685 16.9663 20.0127 16.3888 20.596C15.8113 21.1792 15.4869 21.9703 15.4869 22.7952C15.4869 23.62 15.8113 24.4111 16.3888 24.9944C16.9663 25.5776 17.7495 25.9053 18.5661 25.9053Z"
        fill="white"
        stroke="white"
        strokeWidth="0.72"
      />
    </svg>
  ) : props.type === "courses" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <g clipPath="url(#clip0_346_70972)">
        <path
          d="M16 31.5C16 30.837 16.2634 30.2011 16.7322 29.7322C17.2011 29.2634 17.837 29 18.5 29H32"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 14H32V34H18.5C17.837 34 17.2011 33.7366 16.7322 33.2678C16.2634 32.7989 16 32.163 16 31.5V16.5C16 15.837 16.2634 15.2011 16.7322 14.7322C17.2011 14.2634 17.837 14 18.5 14V14Z"
          stroke="white"
          strokeWidth="2.004"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_346_70972">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "videos" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M18.4797 16.2948C18.4797 15.6558 19.1919 15.2747 19.7235 15.6292L31.2813 23.3343C31.7563 23.651 31.7563 24.349 31.2813 24.6656L19.7235 32.3708C19.1919 32.7252 18.4797 32.3441 18.4797 31.7052V16.2948Z"
        stroke="white"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : props.type === "websites" ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="11" fill="#131313" fillOpacity="0.8" />
      <path
        d="M24 34C29.5228 34 34 29.5229 34 24C34 18.4772 29.5228 14 24 14C18.4772 14 14 18.4772 14 24C14 29.5229 18.4772 34 24 34Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 24H34"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 14C26.5013 16.7384 27.9228 20.2921 28 24C27.9228 27.708 26.5013 31.2617 24 34C21.4987 31.2617 20.0772 27.708 20 24C20.0772 20.2921 21.4987 16.7384 24 14V14Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <></>
  );
}
export default AppsListIcon;
